import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
// import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    marginRight: theme.spacing(0.5),
    backgroundColor: theme.palette.facet.accentBlue20,
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightFacetBold,
    margin: theme.spacing(0.25),
  },
});

const ModifyStrategyChip = ({
  className,
  classes,
  resource,
  disabled,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const handleStrategyOnClick = async () => {
    loadModalCollectionByLink(resource.relationship(fr.relationships.item.name)?.link('related').url());
  };

  return (
    <Chip
      className={classNames(classes.root, className)}
      label={resource.attr('label')}
      onClick={handleStrategyOnClick}
      disabled={disabled}
    />
  );
};

ModifyStrategyChip.defaultProps = {
  className: '',
  disabled: false,
};

ModifyStrategyChip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ModifyStrategyChip);
